// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1AXeA","inputDescription":"styles_inputDescription__1-JBd"};